<template>
  <div class="group-modal-wrapper">
    <div class="group-modal">
      <form>
        <!-- NAME -->
        <label for="groupModalName" class="input-label">{{ $t('group-name') }}</label>
        <div class="input-wrapper" :class="{ 'invalid': !isNameValid }">
          <span class="tms2">D</span>
          <input
            id="groupModalName"
            type="text"
            :placeholder="$t('group-name')"
            v-model="group.name"
            @keyup="isNameValid = true"
            @keydown.enter.prevent
          />
        </div>
        <!-- <template v-if="group.users.length">
          <label for="groupModalUsers" class="input-label">Работници в групата:</label>
          <div class="users-list">
            <span class="tms2">D</span>
            <p v-for="u in group.users" :key="u._id">{{ u.name }}</p>
          </div>
        </template> -->
        <template v-if="group.users">
          <label for="groupModalUsers" class="input-label"
            >Работници в групата:</label
          >
          <div class="users-list" @click="isAddUsersModalOpened = true">
            <span class="tms">t</span>
            <p v-if="!group.users.length"><strong>{{ $t("add-reporters") }}</strong></p>
            <p v-else><strong>{{ $t("edit-group-users") }}</strong></p>

            <span v-if="group.users.length" class="tms2">H</span>
            <p v-for="u in group.users" :key="u._id">{{ u.name }}</p>
          </div>
        </template>
        <div class="group-modal-actions">
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" v-model="group.isActive" />
              <span class="slider"></span>
            </label>
            <label v-if="group.isActive">{{ $t('active-single') }}</label>
            <label v-else>{{ $t('inactive-single') }}</label>
          </div>
          <div class="btns">
            <button v-if="getUser.permissions.isSuperAdmin && id" class="btn btn-delete" type="submit" value="Submit" @click.prevent="deleteGroup">
              <span class="tms">B</span>
              {{ $t('delete') }}
            </button>
            <button
            v-if="!id"
            class="btn btn-new"
            type="submit"
            value="Submit"
            @click.prevent="create"
            >
            <span class="tms">B</span>
            {{ $t('create') }}
          </button>
            <button v-else class="btn btn-new" type="submit" value="Submit" @click.prevent="edit">
              <span class="tms">B</span>
              {{ $t('edit') }}
            </button>
            <button class="btn btn-close" @click.prevent="closeModal(false)">
              <span class="tms">F</span>
              {{ $t('cancel') }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :usersType="'noPermissions'"
        :isCommingFromGroup="true"
        :groupId="group._id"
        :incomingUsers="group.users"
      />
    </transition>
  </div>
</template>

<script>
import AddUsersModal from "../shared/AddUsersModal.vue";
import log from '../mixins/log.js';
import { mapGetters } from 'vuex';
export default {
  mixins: [log],
  props: ['id'],
    components: {
    AddUsersModal,
  },
    computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser'
      // ...
    ]),
  },
  data() {
    return {
      isNameValid: true,
      isAddUsersModalOpened: false,
      group: {
        name: '',
        users:[],
        isActive: true
      },
      users: []
    };
  },
  methods: {
    getGroup() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group/${this.id}`)
        .then(response => {
          this.group = response.data;
          this.getUsers();
        });
    },
    getUsers() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group/users/${this.id}`)
        .then(response => {
          this.users = response.data;
          this.group.users = response.data;
        });
    },
    checkForm() {
      if (!this.group.name) {
        this.isNameValid = false;
      }

      if (this.isNameValid) {
        return true;
      }
      // if not
      return false;
    },
    create() {
      if (this.checkForm()) {
        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/group`, this.group)
          .then((res) => {
            if(res.data && res.data.exists) this.$snotify.error(res.data.exists);
            else this.$snotify.success('Успешно създадена бригада.');
            // this.newLog('newUser', this.user.username);
           if(res.data.users) this.updateUsersInGroup(res.data);
            this.closeModal(true);
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    edit() {
      if (this.checkForm()) {
        this.$http
          .put(`${process.env.VUE_APP_BASE_URI}/group`, this.group)
          .then((res) => {
            if(res.data && res.data.exists) this.$snotify.error(res.data.exists);
            else this.$snotify.success('Промените са записани успешно!');

            // this.newLog('editUser', this.user.username);
           if(res.data.users) this.updateUsersInGroup(this.group);
            this.closeModal(true);
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    deleteGroup(){
        this.$http
          .delete(`${process.env.VUE_APP_BASE_URI}/group/${this.id}`)
          .then((res) => {
            if (res.data.errorMsg) {
              this.$snotify.error(res.data.errorMsg);
            } else {
              this.$snotify.success("Промените са записани успешно!");
              this.closeModal(true);
            }
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error('Нещо се обърка! Моля опитайте отново.');
          })
    },
        // updates users group
    async updateUsersInGroup(group) {
      const promises = [];

      // this.users is before changes and group.users are the new selected in group
      let array =
        this.users.length > group.users.length ? this.users : group.users;

      for (let u of array) {
        promises.push(
          await new Promise((resolve) => {
            this.$http
              .get(`${process.env.VUE_APP_BASE_URI}/auth/users/${u._id}`)
              .then(async (res) => {
                let user = res.data;

                  user.group = null;

                  for (let gu of group.users) {
                    if (gu._id.toString() === user._id.toString())
                      user.group = group;
                  }

                  await new Promise((resolve) => {
                    this.$http
                      .put(
                        `${process.env.VUE_APP_BASE_URI}/auth/users/${user._id}`,
                        user
                      )
                      .then(() => {
                        resolve();
                      })
                      .catch((err) => {
                        console.log(err.response);
                        this.$snotify.error(
                          "Нещо се обърка! Моля опитайте отново."
                        );
                      });
                  });
                resolve();
              })
              .catch((err) => {
                console.log(err.response);
                this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
              });
          })
        );
      }

      if (promises.length) {
        Promise.all(promises)
          .then(() => {})
          .catch((err) => {
            console.log(err.response);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          });
      }
    },
    closeModal(update) {
      this.$emit('close', update);
    },
    closeAddWorkersModal() {
      this.isAddUsersModalOpened = false;
    },
        handleWorkers(workers) {
      // this.report[this.selectedWorkerType][this.selectedWorkerIndex].worker = w;
      this.group.users = [];

      for (let w of workers) {
        this.group.users.push(w);
      }
      this.isAddUsersModalOpened = false;
    },
    handleEvents(e) {
      if (e.code === 'Enter') {
        if (this.id) {
          this.edit();
        } else {
          this.create();
        }
      } else if (e.code === 'Escape') {
        this.closeModal(false);
      }
    }
  },
  mounted() {
    if (this.id) {
      this.getGroup();
    }

    document.body.classList.add("no-scroll");
    this.$on("saveAddUsersModal", this.handleWorkers);
    this.$on("closeAddUsersModal", this.closeAddWorkersModal);
    window.addEventListener('keydown', this.handleEvents);
  },
  destroyed() {
    document.body.classList.remove("no-scroll");
    window.removeEventListener('keydown', this.handleEvents);
  }
};
</script>

<style scoped>
.group-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}
.group-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #6d2600; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 10px 20px 0;
  width: 800px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.group-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.group-modal-actions {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.invalid .mck {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}

/* Responsive */
@media screen and (max-width: 900px) {
  .group-modal {
    width: 90%;
  }
}
@media screen and (max-width: 500px) {
  .group-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .switch-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
  }
  .btns {
    justify-content: center;
  }
  .group-modal-permissions {
    flex-direction: column;
  }
}
@media screen and (max-height: 550px) {
  .group-modal {
    height: 100%;
  }
}
</style>
